import { ChevronLeft, ChevronRight } from 'lucide-react';
import { type Ref } from 'react';
import { trackingAttributes, type Tracking } from '@/lib/heap/trackingAttributes';
import { cn } from '@/lib/utils';

export interface CarouselNavArrowProps {
    direction: 'prev' | 'next';
    onClick: () => void;
    ariaLabel: string;
    className?: string;
    /** Lets the carousel move focus here when the opposite arrow unmounts at a boundary. */
    ref?: Ref<HTMLButtonElement>;
    tracking?: Tracking;
}

const BASE_CLASSES = cn(
    'flex items-center justify-center w-10 h-10 md:w-11 md:h-11 rounded-md border-[1px] shadow-none',
    'bg-white text-(--neutral-black) border-(--neutral-grey-light)',
    'hover:bg-(--neutral-grey-extra-light) hover:text-(--neutral-black)',
    'dark:bg-gz-blue-600 dark:border-gz-blue-500 dark:text-gz-blue-100',
    'dark:hover:bg-gz-blue-500 dark:hover:text-gz-blue-100',
);

export const CarouselNavArrow = ({ direction, onClick, ariaLabel, className, ref, tracking }: CarouselNavArrowProps) => {
    const Icon = direction === 'prev' ? ChevronLeft : ChevronRight;
    return (
        <button
            ref={ref}
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            className={cn(BASE_CLASSES, className)}
            {...trackingAttributes(tracking)}
        >
            {/* Clicks on the glyph would miss the tracking attributes on the button. */}
            <Icon className="pointer-events-none w-6 h-6 md:w-7 md:h-7" />
        </button>
    );
};
